import tree from '../state';
import * as homeService from '../services/homeService';

export const enterHomeAction = ({ params }, replace, callback) => {
    tree.set('loading', true);
    homeService.getHomePage().then(product => {
        tree.set('product', product);
        tree.set('loading', false);
        callback();
    });
};



// WEBPACK FOOTER //
// ./src/actions/homeActions.js